import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./shared";

const FAQS = [
  {
    q: "Are you insured?",
    a: "Yes. We hold public liability and professional indemnity insurance, and we're happy to share certificates with your HR or facilities team before booking.",
  },
  {
    q: "How much space do you need?",
    a: "A meeting room or open area where the group can kneel and practise on manikins — roughly a boardroom-sized space is plenty for a group of 12.",
  },
  {
    q: "What group sizes work best?",
    a: "Sessions are capped at 12 people so everyone gets proper hands-on time. Larger teams simply rotate through back-to-back one-hour sessions across the day.",
  },
  {
    q: "What should people wear?",
    a: "Everyday work clothes are fine, though comfortable clothing is best — CPR practice involves kneeling on the floor.",
  },
  {
    q: "Is the training accredited?",
    a: "No — and that's deliberate. We focus on practical skills and the confidence to act in a real emergency, rather than exams and certificates. Our sessions don't replace your legal workplace first-aid provision — you'll still need appointed first aiders where required — but they give everyone else the confidence to step in too.",
  },
  {
    q: "Where do you cover?",
    a: "We deliver on-site at workplaces anywhere in the UK. Travel is included for most locations — just tell us where you are.",
  },
  {
    q: "Do you bring the equipment?",
    a: "Yes. Manikins, training defibrillators (AEDs), choking simulation manikins and all materials are provided — you just provide the room and the people.",
  },
];

export const Faq = () => (
  <section id="faq" className="border-t border-[#E7E3D9] px-4 py-24 sm:px-6 lg:px-8" data-testid="faq-section">
    <div className="mx-auto max-w-3xl">
      <Reveal className="text-center">
        <h2 className="font-display text-3xl font-bold tracking-tight text-[#14231B] sm:text-4xl lg:text-5xl">
          Questions <span className="text-[#1E7B4F]">HR teams ask</span>
        </h2>
        <p className="mt-4 text-lg text-[#5F6E63]">
          Everything you need to know before booking a session.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className="rounded-2xl border border-[#E7E3D9] bg-white px-6 shadow-sm"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-display text-lg font-semibold text-[#14231B] hover:text-[#1E7B4F] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-relaxed text-[#5F6E63]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
